module.exports = __webpack_public_path__ + "img/control.e4662a34.webp";